import React from "react";
import {
  Layout
} from "../../_metronic/_partials";

export function LayoutPage(props) {
  return <Layout {...props} />;
}
